module.exports = __webpack_public_path__ + "img/foto3.91258877.jpg";